import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios'; // Adjust your axios import path if needed


const CreateTournament = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // THE MASTER FORM STATE
    const [formData, setFormData] = useState({
        tieBreakerOrder: ['totalWinPts','totalPercentage','totalGamePts'],
        oddPlayerStrategy: 'bye',
        name: '',
        gameType: 'Catan',
        date: '',
        time: '',
        location: '',
        description: '',
        
        // Settings (Steps 2 & 3)
        format: 'Swiss',
        hasGroupStage: false,
        cutToTop: 0,
        maxRounds: 3,
        pointsPerWin: 1,
        pointsPerTie: 0,
        pointsPerLoss: 0,
        roundTimer: 0,
        usePowerPairing: false,
        playersPerMatch: 2,
        
        
        // Registration (Step 4)
        regType: 'open',
        minPlayers: 4,
        maxPlayers: 32,
        entryFee: '',
        requireListSubmission: false,
        
    });
       const [gameOptions, setGameOptions] = useState([]);
    const [isLoadingGames, setIsLoadingGames] = useState(true);
    useEffect(() => {
        const fetchGames = async () => {
            try {
                const response = await api.get('/games');
                setGameOptions(response.data);
                
                // If they don't have a game selected yet, default to the first one in the DB!
                if (response.data.length > 0) {
                    setFormData(prev => {
                        if (!prev.gameType) {
                            return { ...prev, gameType: response.data[0].name };
                        }
                        return prev;
                    });
                }
            } catch (err) {
                console.error("Failed to load games", err);
            } finally {
                setIsLoadingGames(false);
            }
        };
        fetchGames();
    }, []);
    const moveTieBreaker = (index, direction) => {
        const newOrder = [...formData.tieBreakerOrder];
        if (direction === 'up' && index > 0) {
            // Swap with the item above it
            [newOrder[index - 1], newOrder[index]] = [newOrder[index], newOrder[index - 1]];
        } else if (direction === 'down' && index < newOrder.length - 1) {
            // Swap with the item below it
            [newOrder[index + 1], newOrder[index]] = [newOrder[index], newOrder[index + 1]];
        }
        setFormData({ ...formData, tieBreakerOrder: newOrder });
    };

    // Human-readable labels for our UI
    const tieBreakerLabels = {
        'totalWinPts': '🏆 Match Points (Wins/Ties)',
        'totalPercentage': '📊 Win Percentage',
        'totalGamePts': '🎲 In-Game Points'
    };
    // --- HANDLERS ---
    const handleNext = () => setStep(prev => Math.min(prev + 1, 5));
    const handleBack = () => setStep(prev => Math.max(prev - 1, 1));

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // --- RENDER STEPS ---
    const renderStep1 = () => (
        <div className="space-y-6 animate-in fade-in slide-in-from-right-4">
            <div>
                <h2 className="text-2xl font-black text-gray-900">Basic Details</h2>
                <p className="text-gray-500 text-sm font-bold">Set the vibe for your event.</p>
            </div>
            
            <div className="space-y-4">
                <div>
                    <label className="block text-xs font-black text-gray-700 uppercase mb-2">Tournament Name *</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required
                        className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 focus:bg-white outline-none transition-all" 
                        placeholder="e.g., Summer Catan Championship" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
    <label className="block text-xs font-black text-gray-700 uppercase mb-3">Select Game</label>
    
    {isLoadingGames ? (
        <div className="text-sm font-bold text-gray-400 animate-pulse">Loading games from database...</div>
    ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {gameOptions.map(game => (
                <button 
                    key={game._id} 
                    type="button" 
                    onClick={() => setFormData({...formData, gameType: game.name})}
                    className={`py-4 rounded-xl border-2 font-black transition-all ${
                        formData.gameType === game.name 
                        ? 'bg-blue-50 border-blue-600 text-blue-700 shadow-sm' 
                        : 'bg-white border-gray-200 text-gray-500 hover:border-gray-300'
                    }`}
                >
                    {game.name}
                </button>
            ))}
        </div>
    )}
</div>
                    <div>
                        <label className="block text-xs font-black text-gray-700 uppercase mb-2">Location</label>
                        <input type="text" name="location" value={formData.location} onChange={handleChange}
                            className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 focus:bg-white outline-none" 
                            placeholder="e.g., The Local Game Store" />
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-xs font-black text-gray-700 uppercase mb-2">Date</label>
                        <input type="date" name="date" value={formData.date} onChange={handleChange}
                            className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold text-gray-700 focus:border-blue-500" />
                    </div>
                    <div>
                        <label className="block text-xs font-black text-gray-700 uppercase mb-2">Time</label>
                        <input type="time" name="time" value={formData.time} onChange={handleChange}
                            className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold text-gray-700 focus:border-blue-500" />
                    </div>
                </div>
            </div>
        </div>
    );

   const renderStep2 = () => {
        // Quick helper variable to check if Official Catan is selected
        const isOfficial = formData.format === 'Official Catan';
        const isCatanVariant = formData.gameType === 'Catan' || formData.gameType === 'Catan Seafarers';

        // DYNAMIC FORMATS: Change options based on the Game Type selected in Step 1
        const availableFormats = isCatanVariant 
            ? ['Swiss', 'Official Catan'] 
            : ['Swiss', 'Knockout', 'Round Robin'];

        // Failsafe: If they selected Knockout, went back, and changed to Catan / Seafarers, force them back to Swiss
        if (isCatanVariant && (formData.format === 'Knockout' || formData.format === 'Round Robin')) {
            setTimeout(() => setFormData({ ...formData, format: 'Swiss' }), 0);
        } else if (!isCatanVariant && formData.format === 'Official Catan') {
            setTimeout(() => setFormData({ ...formData, format: 'Swiss' }), 0);
        }

        return (
            <div className="space-y-6 animate-in fade-in slide-in-from-right-4">
                <div>
                    <h2 className="text-2xl font-black text-gray-900">Tournament Structure</h2>
                    <p className="text-gray-500 text-sm font-bold">How will the matchmaking engine run?</p>
                </div>

                {/* 1. FORMAT SELECTION */}
                <div>
                    <label className="block text-xs font-black text-gray-700 uppercase mb-2">Primary Format</label>
                    <div className={`grid grid-cols-2 ${availableFormats.length > 2 ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-3`}>
                        {availableFormats.map(fmt => (
                            <button 
                                key={fmt} 
                                type="button" 
                                onClick={() => setFormData({...formData, format: fmt})}
                                className={`py-3 px-2 rounded-xl border-2 font-black text-sm transition-all ${
                                    formData.format === fmt 
                                    ? 'bg-blue-50 border-blue-600 text-blue-700 shadow-sm' 
                                    : 'bg-white border-gray-200 text-gray-500 hover:border-gray-300'
                                }`}
                            >
                                {fmt === 'Round Robin' ? 'League' : fmt}
                            </button>
                        ))}
                    </div>
                </div>

                {/* 2. MANUAL SETTINGS (Hidden if Official Catan is selected!) */}
                {!isOfficial && (
                    <div className="space-y-6 animate-in fade-in slide-in-from-top-2">
                        <div>
                            <label className="block text-xs font-black text-gray-700 uppercase mb-2">Players per Match</label>
                            <input type="number" name="playersPerMatch" min="2" max="10" value={formData.playersPerMatch} onChange={handleChange}
                                className="w-full bg-white border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none" />
                            <p className="text-[10px] text-gray-400 font-bold mt-2 uppercase">2 = 1v1 Matches, 4 = Group FFA</p>
                        </div>

                        {!isCatanVariant && Number(formData.playersPerMatch) === 2 && (
                            <div className="animate-in fade-in slide-in-from-top-2">
                                <label className="block text-xs font-black text-gray-700 uppercase mb-2">Odd Player Strategy</label>
                                <select 
                                    name="oddPlayerStrategy" 
                                    value={formData.oddPlayerStrategy} 
                                    onChange={handleChange}
                                    className="w-full bg-white border-2 border-gray-200 rounded-xl px-4 py-3 font-bold text-gray-700 focus:border-blue-500 outline-none"
                                >
                                    <option value="bye">Give 1 Player a BYE (Sit Out)</option>
                                    <option value="group_of_3">Merge into a 3-Player Match</option>
                                </select>
                                <p className="text-[10px] text-gray-400 font-bold mt-2 uppercase">If there is an odd number of players, how should the engine handle the last person?</p>
                            </div>
                        )}

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-gray-50 p-6 rounded-2xl border border-gray-200">
                            <div>
                                <label className="block text-xs font-black text-gray-700 uppercase mb-2">Max Rounds</label>
                                <input type="number" name="maxRounds" min="1" max="20" value={formData.maxRounds} onChange={handleChange}
                                    className="w-full bg-white border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none" />
                                <p className="text-[10px] text-gray-400 font-bold mt-2 uppercase">Engine will auto-override this for Knockout/League.</p>
                            </div>

                            <div>
                                <label className="block text-xs font-black text-gray-700 uppercase mb-2">Hybrid Top Cut?</label>
                                <select name="cutToTop" value={formData.cutToTop} onChange={handleChange}
                                    className="w-full bg-white border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none">
                                    <option value={0}>No Top Cut</option>
                                    <option value={4}>Cut to Top 4</option>
                                    <option value={8}>Cut to Top 8</option>
                                    <option value={16}>Cut to Top 16</option>
                                </select>
                                <p className="text-[10px] text-gray-400 font-bold mt-2 uppercase">Transition to Single Elim after Swiss rounds.</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* 3. OFFICIAL CATAN INFO BOX (Shows when manual settings are hidden) */}
                {isOfficial && (
                    <div className="bg-blue-50 border-2 border-blue-200 p-6 rounded-2xl text-blue-800 animate-in fade-in slide-in-from-top-2">
                        <h3 className="font-black flex items-center gap-2 mb-2">
                            <span className="text-xl">🏆</span> Official Rules Active
                        </h3>
                        <ul className="text-sm font-bold space-y-1 opacity-80 list-disc list-inside">
                            <li>Group sizes strictly enforced to tables of 3 and 4.</li>
                            <li>Elimination cuts & round limits auto-calculated.</li>
                            <li>Serpentine seating automatically applied for cuts.</li>
                        </ul>
                    </div>
                )}

                {/* 4. TIE-BREAKER PRIORITY */}
                <div className="animate-in fade-in slide-in-from-top-2 lg:col-span-2">
                    <label className="block text-xs font-black text-gray-700 uppercase mb-3">Tie-Breaker Priority List</label>
                    <div className="space-y-2 bg-gray-50 p-3 rounded-2xl border border-gray-200">
                        {formData.tieBreakerOrder.map((key, index) => (
                            <div key={key} className="flex items-center justify-between bg-white border border-gray-200 p-3 rounded-xl shadow-sm transition-all hover:border-blue-300">
                                <div className="flex items-center gap-4">
                                    <span className={`w-8 h-8 flex items-center justify-center rounded-lg font-black text-sm ${
                                        index === 0 ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-100 text-gray-500'
                                    }`}>
                                        {index + 1}
                                    </span>
                                    <span className="font-bold text-gray-800">{tieBreakerLabels[key]}</span>
                                </div>
                                
                                <div className="flex flex-col gap-1">
                                    <button 
                                        type="button" 
                                        onClick={() => moveTieBreaker(index, 'up')} 
                                        disabled={index === 0} 
                                        className="text-gray-400 hover:text-blue-600 hover:bg-blue-50 w-6 h-6 flex items-center justify-center rounded transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:cursor-not-allowed"
                                    >
                                        ▲
                                    </button>
                                    <button 
                                        type="button" 
                                        onClick={() => moveTieBreaker(index, 'down')} 
                                        disabled={index === formData.tieBreakerOrder.length - 1} 
                                        className="text-gray-400 hover:text-blue-600 hover:bg-blue-50 w-6 h-6 flex items-center justify-center rounded transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:cursor-not-allowed"
                                    >
                                        ▼
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="text-[10px] text-gray-400 font-bold mt-2 uppercase text-center">Use the arrows to rank how the engine resolves identical scores.</p>
                </div>

            </div>
        );
    };  
    // --- API SUBMIT FUNCTION ---
    const handleLaunch = async () => {
        setIsSubmitting(true);
        try {
            // Map our formData to perfectly match the Phase 5 Mongoose Schema
            const payload = {
                name: formData.name,
                game: formData.gameType,
                date: formData.date,
                time: formData.time,
                location: formData.location,
                description: formData.description,
                settings: {
                    gameType: formData.gameType,
                    format: formData.format,
                    hasGroupStage: formData.hasGroupStage,
                    cutToTop: Number(formData.cutToTop),
                    maxRounds: Number(formData.maxRounds),
                    pointsPerWin: Number(formData.pointsPerWin),
                    pointsPerTie: Number(formData.pointsPerTie),
                    pointsPerLoss: Number(formData.pointsPerLoss),
                    roundTimer: Number(formData.roundTimer),
                    usePowerPairing: formData.usePowerPairing,
                    playersPerMatch: Number(formData.playersPerMatch),
                    oddPlayerStrategy: formData.oddPlayerStrategy,
                    tieBreakerOrder: formData.tieBreakerOrder.split, 
                },
                registration: {
                    type: formData.regType,
                    minPlayers: Number(formData.minPlayers),
                    maxPlayers: Number(formData.maxPlayers),
                    entryFee: formData.entryFee,
                    requireListSubmission: formData.requireListSubmission
                },
                players: [] // Starts empty! Players join in the Waiting Room.
            };
            console.log("Frontend sending playload", payload)
            const { data } = await api.post('/tournaments', payload);
            
            // Success! Send the Master to their new Tournament Control Room
            navigate(`/tournament/${data._id}`);
        } catch (err) {
            console.error('Failed to create tournament', err);
            alert(err.response?.data?.error || "Error creating tournament");
            setIsSubmitting(false);
        }
    };


    // --- RENDER STEPS 3, 4, AND 5 ---
    const renderStep3 = () => (
        <div className="space-y-6 animate-in fade-in slide-in-from-right-4">
            <div>
                <h2 className="text-2xl font-black text-gray-900">Scoring & Rulesets</h2>
                <p className="text-gray-500 text-sm font-bold">Define how points are awarded.</p>
            </div>

            {formData.gameType === 'Catan' || formData.gameType === 'Catan Seafarers' ? (
                <div className="bg-blue-50 border-2 border-blue-200 rounded-2xl p-6 text-blue-800">
                    <h4 className="font-black mb-2 flex items-center gap-2">
                        🎲 {formData.gameType === 'Catan Seafarers' ? 'Catan Seafarers Engine (14 VP Target)' : 'Catan Engine (10 VP Target)'}
                    </h4>
                    <p className="text-sm font-medium">
                        {formData.gameType === 'Catan Seafarers'
                            ? 'Because you selected Catan Seafarers, the Universal Engine will automatically use the Championship ruleset played to 14 Victory Points (Percentage-based tie-breakers and strict Victory Point math). Non-winners can score 10+ points.'
                            : 'Because you selected Catan, the Universal Engine will automatically use the official Championship ruleset played to 10 Victory Points (Percentage-based tie-breakers and strict Victory Point math). Manual point values are disabled.'}
                    </p>
                </div>
            ) : (
                <div className="grid grid-cols-3 gap-4">
                    <div>
                        <label className="block text-xs font-black text-gray-700 uppercase mb-2">Pts per Win</label>
                        <input type="number" name="pointsPerWin" value={formData.pointsPerWin} onChange={handleChange}
                            className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none" />
                    </div>
                    <div>
                        <label className="block text-xs font-black text-gray-700 uppercase mb-2">Pts per Tie</label>
                        <input type="number" name="pointsPerTie" value={formData.pointsPerTie} onChange={handleChange}
                            className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none" />
                    </div>
                    <div>
                        <label className="block text-xs font-black text-gray-700 uppercase mb-2">Pts per Loss</label>
                        <input type="number" name="pointsPerLoss" value={formData.pointsPerLoss} onChange={handleChange}
                            className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none" />
                    </div>
                </div>
            )}

            <div className="bg-gray-50 p-6 rounded-2xl border border-gray-200 space-y-6">
                <div>
                    <label className="block text-xs font-black text-gray-700 uppercase mb-2">Round Timer (Minutes)</label>
                    <input type="number" name="roundTimer" value={formData.roundTimer} onChange={handleChange} placeholder="e.g., 50"
                        className="w-full bg-white border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none" />
                </div>

                {formData.format === 'Swiss' && (
                    <div className="flex items-center justify-between bg-white p-4 rounded-xl border-2 border-gray-100">
                        <div>
                            <span className="text-sm font-black text-gray-800 block">Power Pairing</span>
                            <span className="text-xs font-bold text-gray-400">Force the top 4 players to play together.</span>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" name="usePowerPairing" checked={formData.usePowerPairing} onChange={handleChange} className="sr-only peer" />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                    </div>
                )}
            </div>
        </div>
    );

    const renderStep4 = () => (
        <div className="space-y-6 animate-in fade-in slide-in-from-right-4">
            <div>
                <h2 className="text-2xl font-black text-gray-900">Participant Settings</h2>
                <p className="text-gray-500 text-sm font-bold">Set the gates and capacities.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-xs font-black text-gray-700 uppercase mb-2">Min Players</label>
                    <input type="number" name="minPlayers" value={formData.minPlayers} onChange={handleChange}
                        className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none" />
                </div>
                <div>
                    <label className="block text-xs font-black text-gray-700 uppercase mb-2">Max Players</label>
                    <input type="number" name="maxPlayers" value={formData.maxPlayers} onChange={handleChange}
                        className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none" />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-xs font-black text-gray-700 uppercase mb-2">Registration Type</label>
                    <select name="regType" value={formData.regType} onChange={handleChange}
                        className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none">
                        <option value="open">Open (Anyone can join)</option>
                        <option value="invite">Invite Only</option>
                        <option value="closed">Closed</option>
                    </select>
                </div>
                <div>
                    <label className="block text-xs font-black text-gray-700 uppercase mb-2">Entry Fee</label>
                    <input type="text" name="entryFee" value={formData.entryFee} onChange={handleChange} placeholder="e.g., Free, $10, etc."
                        className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none" />
                </div>
            </div>

            <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-xl border border-gray-200">
                <input type="checkbox" name="requireListSubmission" id="requireListSubmission" checked={formData.requireListSubmission} onChange={handleChange} 
                    className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <label htmlFor="requireListSubmission" className="text-sm font-bold text-gray-700 cursor-pointer">
                    Require players to submit a Roster/Decklist URL upon joining
                </label>
            </div>
        </div>
    );

    const renderStep5 = () => (
        <div className="space-y-6 animate-in fade-in slide-in-from-right-4">
            <div className="text-center">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                </div>
                <h2 className="text-2xl font-black text-gray-900">Ready to Publish</h2>
                <p className="text-gray-500 text-sm font-bold">Review your settings before creating the lobby.</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-2xl border border-gray-200 divide-y divide-gray-200">
                <div className="pb-4 flex justify-between">
                    <span className="text-sm font-bold text-gray-500">Event Name</span>
                    <span className="text-sm font-black text-gray-900">{formData.name || 'Untitled Event'}</span>
                </div>
                <div className="py-4 flex justify-between">
                    <span className="text-sm font-bold text-gray-500">Game & Format</span>
                    <span className="text-sm font-black text-blue-600 bg-blue-50 px-3 py-1 rounded-md">{formData.gameType} • {formData.format}</span>
                </div>
                <div className="py-4 flex justify-between">
                    <span className="text-sm font-bold text-gray-500">Location</span>
                    <span className="text-sm font-black text-gray-900">{formData.location || 'TBA'}</span>
                </div>
                <div className="pt-4 flex justify-between">
                    <span className="text-sm font-bold text-gray-500">Capacity</span>
                    <span className="text-sm font-black text-gray-900">{formData.minPlayers} - {formData.maxPlayers} Players</span>
                </div>
            </div>
        </div>
    );

    return (
        <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6">
            <div className="max-w-3xl mx-auto">
                
                {/* WIZARD HEADER & PROGRESS BAR */}
                <div className="mb-8">
                    <div className="flex justify-between items-center mb-4">
                        <h1 className="text-3xl font-black text-gray-900 tracking-tight">Create Event</h1>
                        <button onClick={() => navigate('/dashboard')} className="text-sm font-bold text-gray-500 hover:text-gray-800">Cancel</button>
                    </div>
                    
                    <div className="flex gap-2">
                        {[1, 2, 3, 4, 5].map(i => (
                            <div key={i} className={`h-2 flex-1 rounded-full transition-colors duration-500 ${
                                i <= step ? 'bg-blue-600' : 'bg-gray-200'
                            }`}></div>
                        ))}
                    </div>
                    <div className="flex justify-between text-[10px] font-black uppercase tracking-widest text-gray-400 mt-2">
                        <span>Details</span>
                        <span>Structure</span>
                        <span>Scoring</span>
                        <span>Players</span>
                        <span>Publish</span>
                    </div>
                </div>

                {/* WIZARD CARD */}
                <div className="bg-white rounded-3xl shadow-xl border border-gray-200 overflow-hidden">
                    <div className="p-8 sm:p-10">
                        
                        {/* DYNAMIC FORM RENDERING */}
                        {step === 1 && renderStep1()}
                        {step === 2 && renderStep2()}
                        {step === 3 && renderStep3()}
                        {step === 4 && renderStep4()}
                        {step === 5 && renderStep5()}

                    </div>
                    
                    {/* BOTTOM NAVIGATION BAR */}
                    <div className="bg-gray-50 px-8 py-5 border-t border-gray-100 flex justify-between items-center">
                        <button 
                            onClick={handleBack} 
                            disabled={step === 1}
                            className={`px-6 py-2 rounded-xl font-bold transition-all ${step === 1 ? 'opacity-0 cursor-default' : 'text-gray-500 hover:bg-gray-200 hover:text-gray-800'}`}
                        >
                            ← Back
                        </button>
                        
                        {step < 5 ? (
        <button 
            onClick={handleNext}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-xl font-black shadow-lg shadow-blue-100 active:scale-95 transition-all"
        >
            Next Step →
        </button>
    ) : (
        <button 
            onClick={handleLaunch} // <--- MAKE SURE THIS IS HERE!
            disabled={isSubmitting}
            className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-xl font-black shadow-lg shadow-green-100 active:scale-95 transition-all"
        >
            {isSubmitting ? 'Creating...' : 'Launch Tournament 🚀'}
        </button>
    )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default CreateTournament;